import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Icon from "react-icons-kit";
import { apple } from "react-icons-kit/fa/apple";
import { windows } from "react-icons-kit/fa/windows";
import { linux } from "react-icons-kit/fa/linux";
import { android } from "react-icons-kit/fa/android";
import { spinner } from "react-icons-kit/fa/spinner";

import { openModal, closeModal } from "@redq/reuse-modal";
import Button from "../../../common/components/Button";
import RequestTrialContactForm from "../RequestTrialContactForm";
import { ContactFormWrapper } from "../RequestTrialContactForm/contactform.style";
import { trackDownload } from "../../../common/analytics";
import { downloadPath } from "../../../common/data/downloads";

// close button for modal
const CloseModalButton = () => (
  <Button
    className="modalCloseBtn"
    variant="fab"
    onClick={() => closeModal()}
    icon={<i className="flaticon-plus-symbol" />}
  />
);

const ModalContent = () => (
  <ContactFormWrapper>
    <RequestTrialContactForm />
  </ContactFormWrapper>
);

const TrialDownloadButton = ({ buttonStyle, className, title, location }) => {
  const [label, setLabel] = useState("Start free");
  const [icon, setIcon] = useState(spinner);
  const [isDownloadable, setDownloadble] = useState(false);
  const [osDetails, setOsDetails] = useState({
    name: "",
    icon: spinner,
    ext: "",
    slug: "",
  });

  useEffect(() => {
    const userAgent = typeof window !== "undefined" && navigator.userAgent;

    let details = {
      name: "Mac",
      icon: apple,
      ext: "dmg",
      slug: "mac",
    };

    if (userAgent.includes("Macintosh")) {
      details.name = "Mac";
      details.icon = apple;
      details.ext = "dmg";
      details.slug = "mac";
      setDownloadble(true);
    }

    if (userAgent.includes("Windows")) {
      details.name = "Windows";
      details.icon = windows;
      details.ext = "exe";
      details.slug = "windows";
      setDownloadble(true);
    }

    if (userAgent.includes("Linux")) {
      details.name = "Linux";
      details.icon = linux;
      details.ext = "AppImage";
      details.slug = "linux";
      setDownloadble(true);
    }

    if (userAgent.includes("iPhone")) {
      details.name = "iPhone";
      details.icon = apple;
      details.ext = "dmg";
      setDownloadble(false);
    }

    if (userAgent.includes("Android")) {
      details.name = "Android";
      details.icon = android;
      details.ext = "AppImage";
      setDownloadble(false);
    }

    setOsDetails(details);
  }, []);

  useEffect(() => {
    if (isDownloadable) {
      setLabel(title || `Start free: download for ${osDetails.name}`);
      setIcon(osDetails.icon);
    } else {
      setLabel(title || `Email me the download link`);
    }
  }, [isDownloadable, osDetails, title]);

  const handleContactFormModal = () => {
    openModal({
      config: {
        className: "contact-form-modal",
        disableDragging: true,
        default: {
          width: "auto",
          height: "auto",
          x: 0,
          y: 0,
        },
      },
      component: ModalContent,
      componentProps: {},
      closeComponent: CloseModalButton,
      closeOnClickOutside: true,
    });
  };

  if (isDownloadable)
    return (
      <a
        href={downloadPath(osDetails.slug)}
        target="_blank"
        rel="noreferrer"
        className={className}
        onClick={() => trackDownload(osDetails.slug, osDetails.ext, location)}
      >
        <Button
          {...buttonStyle}
          title={label}
          icon={<Icon icon={icon} size={24} />}
          iconPosition="right"
        />
      </a>
    );

  return (
    <Button
      {...buttonStyle}
      title={label}
      iconPosition="right"
      onClick={handleContactFormModal}
    />
  );
};

TrialDownloadButton.defaultProps = {
  location: "other",
  buttonStyle: {
    type: "button",
    fontSize: "13px",
    fontWeight: "700",
    borderRadius: "4px",
    pl: "15px",
    pr: "15px",
    colors: "secondaryWithBg",
    minHeight: "auto",
    height: "40px",
  },
};

TrialDownloadButton.propTypes = {
  buttonStyle: PropTypes.object,
  title: PropTypes.string,
  location: PropTypes.string,
};

export default TrialDownloadButton;
